import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Mutation, withApollo } from 'react-apollo';
import { Formik } from 'formik';
import IngredientForm from '~/components/ingredientForm/ingredientForm';
import { ingredientValidationSchema } from '../../validation/ingredient';

export const createIngredientsMutation = gql`
  mutation createIngredient(
    $breweryId: Int!
    $name: String!
    $customsName: String
    $description: String
    $type: IngredientType!
    $measurementType: IngredientMeasurementType!
    $isTracked: Boolean
  ) {
    createIngredient(
      breweryId: $breweryId
      name: $name
      customsName: $customsName
      description: $description
      type: $type
      measurementType: $measurementType
      isTracked: $isTracked
    ) {
      id
      name
      customsName
      breweryId
      description
      type
      measurementType
    }
  }
`;

export const IngredientCreateForm = ({ brewery, history, client }) => (
  <div className="content">
    <Mutation mutation={createIngredientsMutation}>
      {(createIngredient, { error }) => (
        <Formik
          initialValues={{
            type: 'GRAIN',
            measurementType: 'KG'
          }}
          validateOnChange={false}
          validateOnBlur={false}
          validationSchema={ingredientValidationSchema}
          onSubmit={async (values, { setErrors, setSubmitting }) => {
            try {
              const newIngredient = await createIngredient({
                variables: {
                  ...values,
                  breweryId: brewery.id
                },
                refetchQueries: ['ingredients']
              });
              history.push(`/ingredients?new=${newIngredient.data.createIngredient.name}`);
            } catch (err) {
              setErrors({
                unknown: 'An unknown error occured'
              });
              setSubmitting(false);
            }
          }}
          render={IngredientForm}
        />
      )}
    </Mutation>
  </div>
);

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(withRouter(withApollo(IngredientCreateForm)));



// WEBPACK FOOTER //
// ./src/containers/ingredientCreate/ingredientCreate.jsx